export var SET_WEBAPI_URL = 'SET_WEBAPI_URL';
/**
 * Action for switching the api environment,
 * intended for react-native apps so they can
 * quickly switch between test and stage envs.
 *
 * @param  {String} newWebapiUrl - webapi url you wish to use
 * @return {Object} - fsa redux action
 */

export function setWebapiUrl(newWebapiUrl) {
  // NOOP is so that middlewares don't get screwed up by getting null instead of action with a type
  if (process.env.IS_PRODUCTION) return {
    type: 'NOOP'
  };
  return {
    type: SET_WEBAPI_URL,
    payload: newWebapiUrl
  };
}